import { combineReducers } from "redux";

import user from "./authReducer";
import sahakari from "./sahakariReducer";
import collector from "./collectorReducer";
import customer from "./customerReducer";
import batch from "./batchReducer";
import notification from "./notificationReducer";
import transaction from "./transactionReducer";

const rootReducer = combineReducers({
  user,
  sahakari,
  collector,
  customer,
  batch,
  notification,
  transaction,
});

export default rootReducer;
